module.exports = __webpack_public_path__ + "img/ic_photo.c9d8ad1d.svg";